import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePaginationActions from './TablePaginationActions';
import {
    NavLink,
} from "react-router-dom";

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);

function createData(props) {
    for (var i = 0; i < props.length; i++) {
        props[i]["id"] = i + 1;
    }
    return props;
}

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 500,
        margin: "5px 5px"
    },
    tableWrapper: {
        overflowX: 'auto',
    },
});

class CustomPaginationActionsTable extends React.Component {
    state = {
        rows: createData(this.props.tableRowDatas),
        page: 0,
        rowsPerPage: 5,
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    render() {
        var rows = createData(this.props.tableRowDatas);
        const { classes } = this.props;
        const { rowsPerPage, page } = this.state;
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
        var colspanFooter = this.props.tableColumnsAction.length + this.props.tableColumns.length;
        return (
            <Paper className={classes.root}>
                <div className={classes.tableWrapper}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                {this.props.tableColumnsAction.map((col) => { return (<TableCell key={col.className} className={col.className}></TableCell>); })}
                                {this.props.tableColumns.map(col => { return (<TableCell key={col.className} className={col.className}>{col.label}</TableCell>); })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(row => {
                                var actionsList = [];
                                return (
                                    <TableRow key={row.id}>
                                        {this.props.tableColumnsAction.map(col => {
                                            var actions = col.typeAction.split("/");
                                            actionsList.push(actions[0]);
                                            if (row[actions[0]] != null && row[actions[0]] === actions[1]) {
                                                return (
                                                    <TableCell key={`${row.id}-${col.className}`} title={col.label} onClick={col.event(row.id, row.numero)} >
                                                        <NavLink to={`${col.url}/${row.numero}`} >
                                                            {col.icon}
                                                        </NavLink>
                                                    </TableCell>
                                                );
                                            } else {
                                                return (<TableCell key={`${row.id}-${col.className}`} className="disabledButton">{col.icon}</TableCell>);
                                            }
                                        }
                                        )}
                                        {Object.entries(row).map(function (cell, i) {
                                            if (cell[0] !== "id" && actionsList.indexOf(cell[0]) === -1) {
                                                return (<TableCell key={i}>{cell[1]}</TableCell>);
                                            }
                                            return null;
                                        })
                                        }
                                    </TableRow>
                                );
                            })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 48 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    colSpan={colspanFooter}
                                    count={rows.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    labelRowsPerPage="Nombre de lignes par page :"
                                    labelDisplayedRows={this.customeText}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActionsWrapped}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>
            </Paper>
        );
    }

    customeText = () => {
        var nbPages = Math.ceil(this.state.rows.length / this.state.rowsPerPage);
        var pageAffichage = this.state.page + 1;
        return "Page " + pageAffichage + " sur " + nbPages;
    }
}


CustomPaginationActionsTable.propTypes = {
    classes: PropTypes.object.isRequired,
    tableColumns: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    })).isRequired,
    tableColumnsAction: PropTypes.arrayOf(PropTypes.shape({
        className: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
        label: PropTypes.string.isRequired,
        event: PropTypes.func.isRequired,
        url: PropTypes.string.isRequired,
        typeAction: PropTypes.string.isRequired,
    })).isRequired,
    tableRowDatas: PropTypes.array.isRequired,
};

export default withStyles(styles)(CustomPaginationActionsTable);


// WEBPACK FOOTER //
// ./src/components/custom/table/CustomPaginationActionsTable.js